<div >

  <!--<ion-item [routerDirection]="'forward'" routerLink="/trc20" lines="none" class="nav-content">
    <ion-label>
      TRC20
    </ion-label>
  </ion-item>
<ion-item [routerDirection]="'forward'" routerLink="/layout" lines="none" class="nav-content">
    <ion-label>
      Layout
    </ion-label>
  </ion-item>
<ion-item [routerDirection]="'forward'" routerLink="/faq" lines="none" class="nav-content">
    <ion-label>
      FAQ
    </ion-label>
  </ion-item>
<ion-item [routerDirection]="'forward'" routerLink="/support" lines="none" class="nav-content">
    <ion-label>
      Supporto
    </ion-label>
  </ion-item>
-->

  <ion-item (click)="goTo('news')" lines="none" class="nav-content">
    <ion-label> News </ion-label>
  </ion-item>
  <ion-item (click)="goTo('products')" lines="none" class="nav-content">
    <ion-label> I nostri prodotti </ion-label>
  </ion-item>
  <ion-item (click)="goTo('support')" lines="none" class="nav-content">
    <ion-label> Supporto </ion-label>
  </ion-item>
  <ion-item (click)="goTo('settings')" lines="none" class="nav-content">
    <ion-label> Impostazioni </ion-label>
  </ion-item>
  <ion-item (click)="goTo('faq-category')" lines="none" class="nav-content">
    <ion-label>F.A.Q</ion-label>
  </ion-item>
</div>
